import { factoryPermission } from "@/models";

export const AccPermission = {
  CONFIG: factoryPermission("Acc.Conf.WebAccess"),
  CONFIG_TAXES: factoryPermission("Acc.Conf.TaxFullAccess"),
  CONFIG_EMAILS: factoryPermission("Acc.Conf.MailFullAccess"),

  EMPLOYEES_MODULE: factoryPermission("Acc.EmployeeFullAccess"),
  PROGRAM_MODULE: factoryPermission("Acc.ProgramFullAccess"),
  CATEGORY_MODULE: factoryPermission("Acc.CategoryFullAccess"),

  SETTLEMENT_MODULE: factoryPermission("Acc.Settlement.WebAccess"),
  SETTLEMENT_CREATE: factoryPermission("Acc.Settlement.Create"),
  SETTLEMENT_SUBMIT: factoryPermission("Acc.Settlement.Submit"),
  SETTLEMENT_RECEIVE: factoryPermission("Acc.Settlement.Recive"),
  SETTLEMENT_SUBSANAR: factoryPermission("Acc.Settlement.Correct"),
  SETTLEMENT_EXPORT_DGTAL: factoryPermission("Acc.Settlement.ExpDgtal"),
  SETTLEMENT_EXPORT_DETAIL: factoryPermission("Acc.Settlement.ExpDetail"),
  SETTLEMENT_EXPORT_ATTACHS: factoryPermission("Acc.Settlement.ExpAttach"),
};
